import { IQuickEditBaseModel, QuickEditBaseModel } from './QuickEditBase';
import { QuickEditSectionModel, IQuickEditSectionModel } from './QuickEditSection';
export interface IQuickEditModel extends IQuickEditBaseModel {
    date?: string;
    sections: QuickEditSectionModel[];
}

export class QuickEditModel extends QuickEditBaseModel implements IQuickEditModel {
    public date?: string;
    public sections: QuickEditSectionModel[];

    // tslint:disable-next-line: unified-signatures
    constructor(obj?: IQuickEditModel);
    constructor(obj: { sections: IQuickEditSectionModel[] });
    constructor(obj?: any) {
        super(obj);

        if (obj && obj.date != null) {
            this.date = obj.date;
        }

        this.sections = [];
        if (obj && obj.sections !== undefined) {
            obj.sections.forEach((field: QuickEditSectionModel) => {
                this.sections.push(new QuickEditSectionModel(field));
            });
        }
    }
}
